import { Helmet } from 'react-helmet-async';

const MainSEO = () => (

    <Helmet>
        <meta charSet="utf-8" />
        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <title>Gamers Home | AI-Powered Freelancing Platform for Creative Outsourcing</title>
        <meta name="robots" content="index, follow" />
        <meta
            name="description"
            content="Gamers Home combines AI-driven matchmaking with human expertise, simplifying creative outsourcing and freelance talent management for gaming and entertainment companies."
        />
        <meta
            name="keywords"
            content="freelance talent, game development, game artists, animators, designers, game design, indie games, game studios, creative outsourcing, task tracking, project management, startup solutions, scaling businesses, vetted experts, cost-effective teams, AI talent matchmaking, remote teams, flexible hiring, Gamers Home, indie game, indie developer, build your game"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Gamers Home | AI-Powered Freelancing Platform for Creative Outsourcing" />
        <meta
            property="og:description"
            content="Gamers Home combines AI-driven matchmaking with human expertise, simplifying creative outsourcing and freelance talent management for gaming and entertainment companies."
        />
        <meta property="og:image" content="https://storage.googleapis.com/public-platform-assets/brand/logo.svg" />
        <meta property="og:url" content="https://gamershome.studio" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="https://storage.googleapis.com/public-platform-assets/images/cover_large.png" />
        <meta name="twitter:title" content="Gamers Home | AI-Powered Freelancing Platform for Creative Outsourcing" />
        <meta
            name="twitter:description"
            content="Gamers Home combines AI-driven matchmaking with human expertise, simplifying creative outsourcing and freelance talent management for gaming and entertainment companies."
        />
        <meta name="twitter:image" content="https://storage.googleapis.com/public-platform-assets/brand/logo.svg" />

        {/* Google tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-J129V58LXB"></script>
        <script>{`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());

      gtag('config', 'G-J129V58LXB');
    `}</script>
    </Helmet>

);

export default MainSEO;